import ServiceBase from '@/services/ServiceBase';
import TokenService from '@/services/TokenService';
import AccessLogService from '@/services/AccessLogService';
import PersonService from '@/services/PersonService';
import CompanyService from '@/services/CompanyService';
import ControllerService from '@/services/ControllerService';
import ZoneService from '@/services/ZoneService';

// Factory function to create services
const createService = (resource, ServiceClass, baseURL) => {
  const serviceBase = new ServiceBase({ resource, baseURL });
  return new ServiceClass(serviceBase);
};

// Instantiate services
export const tokenService = createService('api/v1/token', TokenService);
export const accessLogService = createService('api/v1/jim-morrinson-logs/access-logs', AccessLogService, process.env.JIM_MORRINSON_BASE_URL);
export const personService = createService('api/v1/persons', PersonService, process.env.JIM_MORRINSON_BASE_URL);
export const companyService = createService('api/v1/companies', CompanyService, process.env.JIM_MORRINSON_BASE_URL);
export const controllerService = createService('api/v1/controllers', ControllerService, process.env.JIM_MORRINSON_BASE_URL);
export const zoneService = createService('api/v1/zones', ZoneService, process.env.JIM_MORRINSON_BASE_URL);



// WEBPACK FOOTER //
// ./src/services/index.js